import { ComponentPropsWithoutRef, FC } from 'react';

type ChevronLeftIconProps = ComponentPropsWithoutRef<'svg'>;

export const ChevronLeftIcon: FC<ChevronLeftIconProps> = ({ color, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M9.98316 12.6105L5.37262 7.99997L9.98316 3.3894L10.6899 4.11295L6.80285 7.99997L10.6899 11.887L9.98316 12.6105Z"
                fill={color || 'currentColor'}
            />
        </svg>
    );
};
